import React from "react";
import PolicyPage from "./PolicyPage";

const TermsAndConditions = () => {
  return (
    <PolicyPage policyType="TermsAndConditions" pageTitle="Terms And Conditions" />
  );
};

export default TermsAndConditions;
